import { CopilotPresetSetting, CopilotPresetSettings, copilotPresetSettings } from '../types'

export function getDefaultPresetSettings(): CopilotPresetSettings {
    const settings = {}

    copilotPresetSettings.forEach((setting) => {
        settings[setting] = defaultValueFromPresetSetting(setting)
    })

    return settings as CopilotPresetSettings
}

export function defaultValueFromPresetSetting(setting: CopilotPresetSetting): boolean {
    switch (setting) {
        // delete this when collections input supports default value
        case 'collections':
            return false
        default:
            return true
    }
}

export function labelFromPresetSetting(setting: CopilotPresetSetting): string {
    switch (setting) {
        case 'collections':
            return 'Collections'
        case 'rating':
            return 'Rating'
        case 'sourceUrl':
            return 'Source URL'
        case 'tags':
            return 'Tags'
        case 'username':
            return 'Username'
        case 'visibility':
            return 'Visibility'
    }
}
